import Vue from "vue";
import App from "./App.vue";
import routerIndex from "./router/index.js";
import routerCompanyUser from "./router/indexCompanyUser.js";
import routerUser from "./router/indexUser.js";

let router = null;
if (window.baseConfig.systemType === "admin") {
  router = routerIndex;
} else if (window.baseConfig.systemType === "companyUser") {
  router = routerCompanyUser;
} else if (window.baseConfig.systemType === "user") {
  router = routerUser;
} else {
  router = routerIndex;
}
import store from "./store";
import "babel-polyfill";
import ElementUI from "element-ui";
// 声音文件
import "@/utils/soundClick.js";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/theme/element-variables.scss";
import "@/utils/directives/validate.js";
//元素改变自定义指令
import "@/utils/directives/resize.js";

import "@/utils/directives/has.js";

import api from "../../common/api/index"; // 导入api接口
// fade/zoom 等
import "element-ui/lib/theme-chalk/base.css";
// collapse 展开折叠
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import base from "@/assets/js/basefunc"; //时间格式化
//Vue.config.silent = true
// 引入Echarts
import echarts from "echarts";

//  v2.0 主题修改
import "./assets/scss/v2.0/ele.scss";

import errPlugin from "../../common/error";
errPlugin(Vue, process.env.NODE_ENV);

import moment from "moment";
Vue.prototype.$moment = moment;
import tmp from "@common/utils/tmp.js";
Vue.prototype.$tmp = tmp;
document.title = window.baseConfig.htmlTitle;
Vue.prototype.$api = api; //将api挂载到vue的原型上复制代码
Vue.prototype.bus = new Vue();
//使用elementUI
Vue.use(ElementUI);
Vue.component(CollapseTransition.name, CollapseTransition);
//使用echarts
//echarts
Vue.prototype.$echarts = echarts;
//vuex
Vue.prototype.$store = store;
Vue.prototype.$base = base;
//事件总线
Vue.prototype.$eventBus = new Vue();
Vue.config.productionTip = false;
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Viewer.setDefaults({
  Options: { inline: false },
});

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  },
});
import ImageViewer from "vue2-viewer";
Vue.use(ImageViewer);
Vue.config.silent = true;
import print from "@/utils/print";
Vue.prototype.$print = print;
// 使用百度地图开发者平台
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, { ak: "" });
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
